import {
  provideClientHydration,
  withHttpTransferCacheOptions,
} from '@angular/platform-browser';
import {
  PreloadAllModules,
  RouteReuseStrategy,
  provideRouter,
  withInMemoryScrolling,
  withPreloading,
  withRouterConfig,
} from '@angular/router';
import {
  IonicRouteStrategy,
  provideIonicAngular,
} from '@ionic/angular/standalone';

import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { JwtModule } from '@auth0/angular-jwt';
import { environment } from '@envs/environment';
import { withNgxsFormPlugin } from '@ngxs/form-plugin';
import { withNgxsRouterPlugin } from '@ngxs/router-plugin';
import { withNgxsStoragePlugin } from '@ngxs/storage-plugin';
import { provideStore } from '@ngxs/store';
import { routes } from './app.routes';
import { AppState } from './store';

// NGXS labs
import { NgxsActionsExecutingModule } from '@ngxs-labs/actions-executing';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { withNgxsResetPlugin } from 'ngxs-reset-plugin';
import { CookieStorageEngine } from './cookie-storage-engine';
import { AuthInterceptor } from './core/auth/auth.interceptor';
import { tokenGetter } from './jwt-token-getter';
import { AppTokenInterceptor } from './interceptors/app-token.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(
      routes,
      withPreloading(PreloadAllModules),
      // withEnabledBlockingInitialNavigation(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
      }),
      withRouterConfig({
        onSameUrlNavigation: 'reload',
      }),
    ),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    provideOAuthClient(),
    importProvidersFrom(
      JwtModule.forRoot({
        config: {
          tokenGetter,
          allowedDomains: [environment.api_domain],
        },
      }),
    ),
    // It is recommended to register the storage plugin before other plugins so initial state can be picked up by those plugins.
    CookieStorageEngine,
    provideStore(
      AppState,
      {
        selectorOptions: {
          suppressErrors: true,
          injectContainerState: false,
        },
        developmentMode: !environment.production,
      },
      withNgxsStoragePlugin({
        keys: [
          { key: 'auth', engine: CookieStorageEngine },
          { key: 'cart', engine: CookieStorageEngine },
        ],
      }),
      withNgxsRouterPlugin(),
      withNgxsFormPlugin(),
      withNgxsResetPlugin(),
    ),
    importProvidersFrom(NgxsActionsExecutingModule.forRoot()),
    ...environment.plugins,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppTokenInterceptor,
      multi: true,
    },
    provideClientHydration(
      withHttpTransferCacheOptions({
        includePostRequests: true,
        includeRequestsWithAuthHeaders: true,
      }),
    ),
  ],
};
